<template>
    <div class="d-flex align-center">
        <v-progress-circular width="2" size="16" indeterminate color="primary"></v-progress-circular>
        <span class="d-inline-block ml-2">Loading Cart...</span>
    </div>
</template>

<script lang="ts" setup></script>